import { Input, Select } from "antd";
import { useState } from "react";
import NumberFormat from "react-number-format";
import { cnpjInputMask, cpfInputMask } from "../../utils";

interface InputParams {
  name?: string;
  disabled?: boolean;
  placeholder?: string;
  onBlur?: any;
}

interface MaskInputParams {
  name?: string;
  mask?: string;
  placeholder?: string;
  disabled?: boolean;
  onBlur?: any;
}

interface NumberInputParams extends InputParams {
  prefix?: string;
  decimalScale?: number;
  allowNegative?: boolean;
}

interface SelectInputParams extends InputParams {
  name?: string;
  options?: { label: string; value: any }[];
  onBlur?: any;
}

// Helper function to apply mask
const applyMask = (value: string, mask: string): string => {
  let result = '';
  let valueIndex = 0;
  
  for (let i = 0; i < mask.length && valueIndex < value.length; i++) {
    if (mask[i] === '9') {
      if (/\d/.test(value[valueIndex])) {
        result += value[valueIndex];
        valueIndex++;
      }
    } else {
      result += mask[i];
      if (value[valueIndex] === mask[i]) {
        valueIndex++;
      }
    }
  }
  
  return result;
};

export const TextInput = ({ placeholder, disabled, ...rest }: InputParams) => (
  <Input
    placeholder={placeholder}
    disabled={disabled}
    onBlur={(e) => {
      if (rest.onBlur) {
        rest.onBlur(rest.name, e.target.value);
      }
    }}
  />
);

export const SelectInput = ({
  placeholder,
  disabled,
  options,
  ...rest
}: SelectInputParams) => (
  <Select
    placeholder={placeholder}
    disabled={disabled}
    options={options}
    getPopupContainer={(trigger) => trigger.parentNode}
  />
);

export const SelectMultipleInput = ({
  disabled,
  assessoresSelected,
  handleChangeAssessores,
  professionals = [],
}: any) => {
  return (
    <Select
      mode="multiple"
      allowClear
      size="large"
      style={{ width: "100%", height: "auto" }}
      placeholder="Selecione os assessores desejados"
      value={assessoresSelected}
      onChange={handleChangeAssessores}
      disabled={disabled}
      optionFilterProp="label"
      getPopupContainer={(trigger) => trigger.parentNode}
    >
      {professionals.map((professional: any) => (
        <Select.Option value={professional._id} label={professional.name}>
          <div className="demo-option-label-item">{professional.name}</div>
        </Select.Option>
      ))}
    </Select>
  );
};

export const NumberInput = ({
  prefix = "",
  disabled = false,
  decimalScale = 2,
  placeholder = "",
  allowNegative = false,
}: NumberInputParams) => (
  <NumberFormat
    disabled={disabled}
    prefix={prefix}
    decimalSeparator=","
    thousandSeparator="."
    placeholder={placeholder}
    decimalScale={decimalScale}
    allowNegative={allowNegative}
    className="ant-input ant-input-lg"
  />
);

export const MaskInput = ({
  mask = "",
  placeholder = "",
  disabled = false,
  ...rest
}: MaskInputParams) => {
  const [value, setValue] = useState("");
  
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = e.target.value.replace(/\D/g, '');
    const maskedValue = applyMask(inputValue, mask);
    setValue(maskedValue);
  };

  return (
    <Input
      value={value}
      onChange={handleChange}
      disabled={disabled}
      placeholder={placeholder}
      className="ant-input ant-input-lg"
      onBlur={(e) => {
        if (rest.onBlur) {
          rest.onBlur(rest.name, e.target.value);
        }
      }}
    />
  );
};

export const MaskCpfCnpjInput = ({
  mask = "",
  placeholder = "",
  disabled = false,
  ...rest
}: MaskInputParams) => {
  const [controlledInput, setControlledInput] = useState("");
  const [isCnpj, setIsCnpj] = useState(false);
  const selectMask = isCnpj
    ? cnpjInputMask
    : controlledInput.length > 0
    ? cpfInputMask
    : "";
    
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value.replaceAll(/[._-]/g, "");
    if (mask === cpfInputMask) {
      if (value.length > 11) {
        setIsCnpj(true);
        setControlledInput(value);
      } else if (value.length >= 11 && controlledInput.length >= 11) {
        setIsCnpj(true);
      } else if (value.length < 11 && controlledInput.length < 11) {
        setIsCnpj(false);
      }
    }
    setControlledInput(value);
  };

  return (
    <Input
      value={controlledInput}
      onChange={handleChange}
      disabled={disabled}
      placeholder={placeholder}
      className="ant-input ant-input-lg"
      onBlur={(e) => {
        if (rest.onBlur) {
          rest.onBlur(rest.name, e.target.value);
        }
      }}
    />
  );
};
